export const nl = {
  // Navigation
  nav: {
    home: 'Home',
    findHairstylist: 'Zoeken',
    forum: 'Meisjesforum',
    about: 'Over ons',
  },
  // Header
  header: {
    account: 'Account',
    connected: 'Verbonden',
    hairstylistAccount: 'Kappersaccount',
    clientAccount: 'Klantenaccount',
    viewProfile: 'Mijn kappersprofiel bekijken',
    favorites: 'Mijn favorieten',
    reviews: 'Mijn beoordelingen',
    myPosts: 'Mijn vragen',
    favoritePosts: 'Mijn favoriete vragen',
    accountSettings: 'Mijn account',
    logout: 'Uitloggen',
    login: 'Inloggen',
    signup: 'Registreren',
    addHairstylist: 'Een kappersprofiel toevoegen',
    messages: 'Berichten',
    iAmProvider: 'Ik bied een service aan',
    dashboard: 'Dashboard',
    manageSubscription: 'Mijn abonnement beheren',
    verifyEmail: 'E-mail verifiëren',
    pendingEmails: 'E-mails in behandeling',
    dashboardAnalytics: 'Dashboard Analytics',
    chooseProviderType: 'Kies uw type dienstverlening',
    editProfile: 'Mijn profiel bewerken',
    upgradeToPro: 'Upgraden naar PRO',
  },
  // Home Page
  home: {
    heroTitle: 'Vind jouw',
    heroAfro: 'Afro-kapster',
    heroClicks: '',
    heroSubtitle: 'en andere onafhankelijke beauty professionals',
    findButton: 'Ik zoek een beauty pro!',
    signupButton: 'Ik bied een service aan, schrijf me in!',
    checking: 'Controleren...',
    lastProfiles: 'Laatst aangemaakte profielen',
    loading: 'Laden...',
    mockupAlt: 'App-voorbeeld',
    existingProfileTitle: 'Je hebt al een kappersprofiel ✨',
    existingProfileMessage: 'Je account is al gekoppeld aan een profiel in de directory. Je kunt het direct bekijken en bewerken.',
    viewMyProfile: 'Mijn profiel bekijken',
    close: 'Sluiten',
    statsText: '120+ Afro-kapsters geregistreerd • De grootste database in België',
    statsTextMobile: '120+ Afro-kapsters geregistreerd in België',
    newBadge: 'Nieuw bij Chérie Coiffer',
    newBadgeAriaLabel: 'Ga naar de sectie Nieuw bij Chérie Coiffer',
    providerHair: 'Kapsel',
    providerNails: 'Nagels',
    providerMakeup: 'Make-up',
    providerEyelash: 'Wimpers',
    providerSale: 'Verkoop',
    selectProviderType: 'Welke service bied je aan?',
  },
  // Search Page
  search: {
    title: 'Een kapster vinden',
    filters: 'Filters',
    sort: 'Sorteren',
    sortBy: 'Sorteren op',
    ascending: 'Oplopend',
    descending: 'Aflopend',
    photosAvailable: 'Foto\'s beschikbaar',
    country: 'Land',
    allCountries: 'Alle landen',
    noCountryFound: 'Geen land gevonden',
    belgium: 'België',
    france: 'Frankrijk',
    switzerland: 'Zwitserland',
    city: 'Stad',
    cityPlaceholder: 'Zoek een stad...',
    name: 'Naam van de kapster',
    namePlaceholder: 'Zoek op naam...',
    services: 'Diensten',
    categories: 'Categorieën',
    kidsAccepted: 'Accepteert kinderen',
    menAccepted: 'Accepteert mannen',
    canTravel: 'Kan reizen',
    hasPhotos: 'Met foto\'s',
    results: 'resultaten',
    noResults: 'Geen resultaten gevonden',
    clearFilters: 'Filters resetten',
    apply: 'Toepassen',
    close: 'Sluiten',
    generalInfo: 'Algemene informatie',
    sortByDistance: 'Afstand',
    sortByRating: 'Beoordeling',
    sortByUpdated: 'Laatst bijgewerkt',
    sortByCreated: 'Aanmaakdatum',
    refineSearch: 'Zoekopdracht verfijnen',
    searchByCityService: 'Zoek op stad, dienst...',
    searching: 'Zoeken…',
    removeCity: '{city} verwijderen',
    coiffesChildren: 'Knipt kinderen',
    coiffesMen: 'Knipt mannen',
    canTravelLabel: 'Kan reizen',
    photosAvailableLabel: 'Foto\'s beschikbaar',
    sortDefault: 'Standaard',
    sortDistance: 'Afstand',
    sortRating: 'Beoordelingen',
    sortAlphabetical: 'Alfabetische volgorde',
    sortCreatedAt: 'Aanmaakdatum',
    sortAscending: 'Oplopend sorteren',
    sortDescending: 'Aflopend sorteren',
    expand: 'Uitvouwen',
    collapse: 'Inklappen',
    serviceTypes: 'Soorten diensten',
    loadingCategories: 'Categorieën laden…',
    reset: 'Resetten',
    otherServices: 'Andere diensten',
    viewList: 'Lijst',
    viewMap: 'Kaart',
    activeFilter: 'actief filter',
    youAreProvider: 'Ben je {provider}?',
    signupHere: 'Meld je hier aan.',
    found: 'gevonden',
    foundSingular: 'gevonden',
    providers: 'dienstverleners',
    provider: 'dienstverlener',
    providerRegistration: 'Dienstverlener registratie',
    allResultsShown: 'Je hebt alles gezien ✨',
    profileNotPublished: 'Je profiel is nog niet gepubliceerd. Activeer je abonnement om zichtbaar te worden.',
    activateProfile: 'Mijn profiel activeren',
  },
  // Hairstylist Card
  card: {
    canTravel: '(kan reizen)',
    photosAvailable: 'Foto\'s beschikbaar',
    photos: 'Foto\'s',
    contact: 'Contact',
    viewProfile: 'Profiel bekijken',
  },
  // Hairstylist Detail
  detail: {
    back: 'Terug',
    addToFavorites: 'Toevoegen aan favorieten',
    removeFromFavorites: 'Verwijderen uit favorieten',
    contact: 'Contact',
    services: 'Diensten',
    description: 'Beschrijving',
    gallery: 'Fotogalerij',
    reviews: 'Klantbeoordelingen',
    rating: 'Beoordeling',
    noReviews: 'Nog geen beoordelingen',
    writeReview: 'Een beoordeling schrijven',
    editReview: 'Mijn beoordeling bewerken',
    deleteReview: 'Mijn beoordeling verwijderen',
    reviewPlaceholder: 'Schrijf je beoordeling hier...',
    submitReview: 'Publiceren',
    cancel: 'Annuleren',
    delete: 'Verwijderen',
    edit: 'Bewerken',
    save: 'Opslaan',
    freeProfile: 'Gratis profiel (beperkt)',
    proProfile: 'PRO-profiel',
    emptyState: 'Selecteer een kaart om de details te bekijken',
    generalInfo: 'Algemene informatie',
    profileName: 'Profilnaam',
    notSpecified: 'Niet opgegeven',
    deleteProfile: 'Profiel verwijderen',
    mainCity: 'Hoofdstad',
    citiesServed: 'Bediente steden',
    presentation: 'Presentatie',
    coordinates: 'Contactgegevens',
    primaryContact: 'Primair sociaal netwerk',
    photos: 'Foto\'s',
    profilePhoto: 'Profiel foto',
    galleryPhoto: 'Galerij',
    servicesOffered: 'Aangeboden diensten',
    loginToReview: 'Log in om een beoordeling te schrijven',
    giveReview: 'Beoordeling schrijven',
    confirmDeleteReview: 'Weet je zeker dat je je beoordeling wilt verwijderen?',
    deleting: 'Verwijderen...',
    anonymousUser: 'Anonieme gebruiker',
    yourReview: '(Jouw beoordeling)',
    unknownDate: 'Onbekende datum',
    identificationCode: 'Identificatiecode:',
    prevPhoto: 'Vorige foto',
    nextPhoto: 'Volgende foto',
    errorDeleteProfile: 'Fout bij het verwijderen van het profiel.',
    errorDelete: 'Fout bij het verwijderen',
  },
  // Posts
  posts: {
    title: 'Meisjesforum',
    subtitle: 'Hier kun je vragen stellen, je ervaringen delen en anderen helpen.',
    createPost: 'Een vraag aanmaken',
    askQuestion: '+ Een vraag stellen',
    editPost: 'Vraag bewerken',
    deletePost: 'Vraag verwijderen',
    noPosts: 'Nog geen vragen',
    writeComment: 'Een opmerking schrijven',
    addComment: 'Een opmerking toevoegen',
    commentPlaceholder: 'Schrijf een opmerking...',
    publish: 'Publiceren',
    seeMoreComments: 'De {count} vorige opmerkingen bekijken',
    seeLessComments: 'Minder weergeven',
    addPhotos: 'Foto\'s toevoegen',
    titlePlaceholder: 'Titel van je vraag',
    contentPlaceholder: 'Inhoud van je vraag...',
    loading: 'Laden...',
  },
  // Profile
  profile: {
    title: 'Mijn profiel',
    favorites: 'Mijn favorieten',
    reviews: 'Mijn beoordelingen',
    myPosts: 'Mijn vragen',
    favoritePosts: 'Mijn favoriete vragen',
    noFavorites: 'Je hebt nog geen favorieten',
    noReviews: 'Je hebt nog geen beoordelingen geschreven',
    noPosts: 'Je hebt nog geen vragen aangemaakt',
    unpublishedTitle: 'Profiel niet gepubliceerd',
    unpublishedMessage: 'Je profiel is nog niet zichtbaar op het platform. Voltooi je betaling om het te publiceren.',
    signInToActivate: 'Log in om je profiel te activeren',
    signInToActivateText: 'Je hebt een e-mail ontvangen om je profiel te activeren. Log in om door te gaan.',
    finalizePayment: 'Betaling voltooien',
  },
  // Payment
  payment: {
    title: 'Verhoog je professionele zichtbaarheid',
    subtitle: 'Kies het plan dat bij je past',
    freeTitle: 'Gratis Profiel',
    freeSubtitle: 'Ideaal om zichtbaar te worden, met beperkte functies.',
    proTitle: 'PRO-profiel',
    proSubtitle: 'Volledige versie van het profiel, om je zichtbaarheid te verhogen.',
    popular: 'Meest populair',
    price: '{price}/maand',
    perMonth: '/maand',
    free: 'Gratis',
    createFree: 'Gratis beginnen',
    activatePro: 'Mijn abonnement activeren',
    freeNote: 'Blijf zo lang gratis als je wilt.',
    priceProtection: 'Prototype prijs: zolang je geabonneerd blijft, stijgt je tarief nooit.',
    creating: 'Aanmaken...',
    redirecting: 'Doorverwijzen...',
    successTitle: 'Profiel succesvol aangemaakt!',
    successMessage: 'Gefeliciteerd! Je gratis profiel is aangemaakt. Je kunt nu zichtbaar worden in onze directory.',
    viewProfile: 'Mijn profiel bekijken',
    backHome: 'Terug naar home',
    errorMissingData: 'Kan profiel niet aanmaken: profielgegevens ontbreken. Start de registratie opnieuw.',
    errorPaymentData: 'Kan betaling niet starten: profielgegevens ontbreken. Start de registratie opnieuw.',
    errorEmail: 'Kan betaling niet starten: het e-mailadres van het account ontbreekt.',
    errorCheckout: 'Fout bij het aanmaken van de betalingssessie. Probeer het opnieuw.',
    errorProfileCreation: 'Fout bij het aanmaken van het profiel',
    feature1: 'Zichtbaar in directory',
    feature2: 'Naam + stad + diensten zichtbaar',
    feature3: 'Volledige fotogalerij',
    feature4: 'Klantbeoordelingen zichtbaar',
    feature5: 'Gemiddelde beoordeling weergegeven',
    feature6: 'Prioriteit in zoekresultaten',
    feature7: 'Toegang tot een eenvoudig profiel',
    feature8: 'Geverifieerd PRO-badge',
    feature9: 'Prioriteitsondersteuning',
    feature10: 'Mogelijkheid om op elk moment naar PRO te upgraden',
    // Pagina 3 – Account aangemaakt, PRO-optie
    successAccountCreated: 'Je account is aangemaakt! 🎉',
    successSubtitle: 'Je kunt het platform nu al vrij gebruiken.',
    successProIntro: 'Wil je meer zichtbaarheid? Ontdek de PRO-optie:',
    proCardTitle: 'PRO-profiel – €9,99/maand',
    proCardSubtext: 'Directe zichtbaarheidsboost',
    proFeaturePriority: 'Altijd prioriteit in zoekresultaten',
    proFeatureGallery: 'Fotogalerij zichtbaar voor iedereen',
    proFeatureReviews: 'Beoordelingen & sterren zichtbaar',
    proFeatureDashboard: 'Dashboard & statistieken',
    proFeatureServices: 'Gedetailleerde dienstenlijst',
    proFeatureCancel: 'Op elk moment opzegbaar',
    goProButton: 'Ga nu naar PRO',
    securityText: 'Veilige betaling (SSL & Stripe) – Geen verborgen kosten',
    skipUpgrade: 'Nee bedankt, bij FREE blijven',
    errorProfileNotFound: 'Fout: profiel niet gevonden. Start de registratie opnieuw.',
    errorUserNotConnected: 'Fout: gebruiker niet verbonden.',
    signInToActivate: 'Log in om je profiel te activeren',
    signInToActivateText: 'Je hebt een e-mail ontvangen om je profiel te activeren. Log in met je account om door te gaan.',
    signIn: 'Inloggen',
    errorStripeNotConfigured: 'Stripe is nog niet geconfigureerd. Stel REACT_APP_STRIPE_PUBLISHABLE_KEY in of vervang STRIPE_PUBLISHABLE_KEY in PaymentPage.jsx.',
    errorStripeInit: 'Kan Stripe niet initialiseren. Controleer of het script https://js.stripe.com/v3 is geladen.',
    errorRedirectStripe: 'Fout bij doorverwijzen naar Stripe. Probeer het opnieuw.',
    // Subscription Success Page
    subscriptionActivated: 'Abonnement geactiveerd',
    subscriptionActivatedSubtitle: 'Je profiel is nu zichtbaar in de directory. Klanten kunnen je vinden, liken en beoordelingen achterlaten 💗',
    subscriptionActiveStatus: 'Abonnement: ACTIEF',
    subscriptionDetails: 'Abonnementdetails',
    plan: 'Plan:',
    professionalPlan: 'Professioneel abonnement — €9,99/maand',
    autoRenewal: 'Automatische verlenging:',
    enabled: 'Ingeschakeld',
    nextInvoice: 'Volgende factuur:',
    manageSubscription: 'Mijn abonnement beheren',
    nextSteps: 'Volgende stappen',
    completeProfile: 'Voltooi je profiel',
    completeProfileDescription: 'Voeg meer details toe om meer klanten aan te trekken',
    addPhotos: 'Voeg foto\'s toe',
    addPhotosDescription: 'Toon je beste creaties in je galerij',
    addPhotosButton: 'Foto\'s toevoegen',
    inviteReviews: 'Nodig je klanten uit om een beoordeling achter te laten',
    inviteReviewsDescription: 'Deel de link naar je profiel om beoordelingen te ontvangen',
    copyReviewLink: 'Mijn beoordelingslink kopiëren',
    linkCopied: 'Link gekopieerd naar klembord!',
    communityMessage: 'Je maakt nu deel uit van de Chérie Coiffer community 💜',
    proudMessage: 'We zijn zo trots om je bij ons te hebben.',
    ifYouHaveQuestion: 'Als je een vraag hebt:',
    accessStylistSpace: 'Toegang tot mijn Stylist Space →',
    germanMandatoryTitle1: 'Gefeliciteerd, je profiel is aangemaakt!',
    germanMandatoryTitle2: 'Voltooi je registratie',
    germanMandatorySubtitle: 'Betaling is vereist om je profiel op het platform te publiceren',
    germanReadyTitle: 'Bijna klaar!',
    germanReadySubtitle: 'Activeer je profiel om op de kaart te verschijnen en zichtbaar te zijn voor klanten.',
    germanPreviewLabel: 'Zo zien klanten je',
    germanProVisibility: 'PRO-zichtbaarheid',
    germanEarlyAccess: 'Early access prijs. Altijd opzegbaar. Geen verborgen kosten.',
    germanBenefitMap: 'Op de stadskaart verschijnen',
    germanBenefitSearch: 'Vindbaar op dienst',
    germanBenefitPhotos: 'Je foto\'s en beoordelingen tonen',
    germanBenefitStats: 'Toegang tot je statistieken',
    germanActivateButton: 'Mijn profiel activeren',
    germanActivateNote: 'De meeste stylisten activeren binnen 2 minuten.',
    paywallPreviewLabel: 'Preview van je openbare profiel',
    paywallCtaGoLive: 'Mijn profiel nu activeren',
    paywallPillRecommended: 'Aanbevolen',
    paywallMicrocopy: 'Altijd opzegbaar · Geen verborgen kosten',
    finalizePay: 'Voltooien en betalen',
    proFeatureVerifiedBadge: 'Geverifieerd PRO-badge',
    proFeatureSearchable: 'Klanten kunnen je vinden op stad en dienst',
  },
  // Account Settings
  account: {
    title: 'Mijn account',
    accountInfo: 'Mijn informatie',
    username: 'Gebruikersnaam',
    email: 'E-mail',
    creationDate: 'Aanmaakdatum',
    actions: 'Acties',
    changePassword: 'Mijn wachtwoord wijzigen',
    deleteAccount: 'Mijn account verwijderen',
    subscription: 'Mijn abonnement',
    subscriptionActive: 'Actief abonnement',
    subscriptionInactive: 'Geen actief abonnement',
    deleteWarning: 'Waarschuwing',
    deleteWarningMessage: 'Als je je account verwijdert en je hebt een actief abonnement, wordt het geannuleerd en kun je niet meer bij je PRO-profiel.',
    confirmDelete: 'Verwijdering bevestigen',
    cancel: 'Annuleren',
    passwordModal: {
      title: 'Mijn wachtwoord wijzigen',
      currentPassword: 'Huidig wachtwoord',
      newPassword: 'Nieuw wachtwoord',
      confirmPassword: 'Nieuw wachtwoord bevestigen',
      change: 'Wijzigen',
      cancel: 'Annuleren',
    },
  },
  // Common
  common: {
    loading: 'Laden...',
    error: 'Fout',
    success: 'Succes',
    save: 'Opslaan',
    cancel: 'Annuleren',
    delete: 'Verwijderen',
    edit: 'Bewerken',
    close: 'Sluiten',
    back: 'Terug',
    next: 'Volgende',
    previous: 'Vorige',
    search: 'Zoeken',
    filter: 'Filteren',
    clear: 'Wissen',
    submit: 'Verzenden',
    confirm: 'Bevestigen',
    notSpecified: 'Niet gespecificeerd',
  },
  // Chat
  chat: {
    button: 'Chat',
    title: 'Chat met ons',
    subtitle: 'We reageren meestal binnen 24 uur',
    namePlaceholder: 'Je naam',
    emailPlaceholder: 'Je e-mail',
    startChat: 'Gesprek starten',
    messagePlaceholder: 'Typ je bericht...',
    emptyState: 'Start het gesprek! 👋',
    close: 'Sluiten',
  },
  // Auth Modal
  auth: {
    login: 'Inloggen',
    signup: 'Registreren',
    resetPassword: 'Wachtwoord opnieuw instellen',
    username: 'Gebruikersnaam',
    usernamePlaceholder: 'Bijv: marie_braids78',
    email: 'E-mail',
    emailOrUsername: 'E-mail of gebruikersnaam',
    emailPlaceholder: 'Bijv: marie@example.com',
    emailOrUsernamePlaceholder: 'Bijv: marie_braids78 of marie@mail.com',
    password: 'Wachtwoord',
    passwordPlaceholder: 'Minstens 6 tekens',
    confirmPassword: 'Bevestig wachtwoord',
    confirmPasswordPlaceholder: 'Voer je wachtwoord opnieuw in',
    forgotPassword: 'Wachtwoord vergeten?',
    sendLink: 'Link verzenden',
    connect: 'Inloggen',
    signupButton: 'Registreren',
    noAccount: 'Nog geen account? Registreren',
    hasAccount: 'Al een account? Inloggen',
    loading: 'Laden...',
    sending: 'Verzenden...',
    resendLink: 'Link opnieuw verzenden',
    resetEmailSent: 'Er is een e-mail voor het opnieuw instellen van je wachtwoord naar je verzonden. Controleer je mailbox.',
    verificationEmailResent: 'Verificatie-e-mail opnieuw verzonden! Controleer je mailbox.',
    pleaseEnterEmail: 'Voer je e-mailadres in.',
    usernameRequired: 'Gebruikersnaam is verplicht.',
    usernameInvalid: 'Gebruikersnaam mag alleen letters, cijfers, streepjes (-), underscores (_) en punten (.) bevatten.',
    emailInvalid: 'Het e-mailadres is niet geldig. Voer een geldig e-mailadres in.',
    passwordMinLength: 'Wachtwoord moet minimaal 6 tekens bevatten.',
    passwordsDontMatch: 'Wachtwoorden komen niet overeen.',
    usernameTaken: 'Deze gebruikersnaam is al in gebruik. Kies een andere.',
    emailTaken: 'Dit e-mailadres wordt al gebruikt. Log in of gebruik een ander e-mailadres.',
    errorOccurred: 'Er is een fout opgetreden',
    networkError: 'Verbindingsprobleem. Controleer uw internetverbinding (Wi‑Fi of mobiele data) en probeer het opnieuw.',
    verificationEmailError: 'Fout bij het verzenden van de verificatie-e-mail.',
  },
  // Language
  language: {
    french: 'Français',
    english: 'English',
    german: 'Deutsch',
    dutch: 'Nederlands',
  },
  // Signup Page
  signup: {
    alreadyHairstylistTitle: 'Je hebt al een kappersprofiel ✨',
    alreadyHairstylistMessage: 'Je account is al gekoppeld aan een profiel in de directory. Je kunt het direct bekijken of bewerken.',
    viewMyProfile: 'Mijn profiel bekijken',
    welcomeTitle: 'Welkom, mooie!',
    welcomeSubtitle: 'Vul dit formulier in om lid te worden van onze directory.',
    chatWelcomeMessage: 'Welkom bij Chérie Coiffer! 💜 Bedankt dat je lid bent geworden van onze community van kapsters. Als je vragen hebt, beantwoord gewoon dit bericht — we zijn er voor je.',
    infoBox: 'Het hoeft niet perfect te zijn, je kunt deze informatie later altijd nog wijzigen.',
    createAccountTitle: 'Maak je account aan',
    createAccountSubtitle: 'Laatste stap: maak je account aan om je registratie af te ronden.',
    createAccountSubtitle2: 'Deze informatie stelt je in staat om in te loggen en je profiel te beheren.',
    section1Title: 'Algemene informatie',
    section1Subtitle: 'Enkele informatie om je profiel te presenteren.',
    profileName: 'Profilnaam',
    profileNamePlaceholder: 'Bijv: Aya Braid Studio',
    country: 'Land',
    selectCountry: 'Selecteer een land',
    noCountryFound: 'Geen land gevonden',
    mainCity: 'Hoofdstad',
    mainCityPlaceholder: 'Bijv: Parijs',
    canTravel: 'Ik kan naar het huis van de klant reizen',
    addCity: 'Voeg een bediende stad toe',
    presentation: 'Presentatie',
    presentationPlaceholder: 'Leg uit hoe je werkt, wat je aanbiedt, je diensten…',
    section2Title: 'Contactgegevens',
    section2Subtitle: 'Hoe kunnen klanten je bereiken?',
    primaryContact: 'Primair sociaal netwerk',
    selectPrimary: 'Selecteren',
    primaryContactHelp: 'Het primaire netwerk wordt getoond op je kaart. Je andere contactopties zijn zichtbaar op je profielpagina.',
    section3Title: 'Foto\'s',
    section3Subtitle: 'Voeg een portret en enkele werkvoorbeelden toe (max. 6).',
    profilePhoto: 'Profielfoto',
    addPhoto: 'Foto toevoegen',
    remove: 'Verwijderen',
    section4Title: 'Welke diensten bied je aan?',
    section4Subtitle: 'Selecteer alle overeenkomende diensten.',
    loadingCategories: 'Categorieën laden…',
    username: 'Gebruikersnaam',
    usernamePlaceholder: 'Bijv: marie_braids78',
    email: 'E-mail',
    emailPlaceholder: 'Bijv: marie@example.com',
    password: 'Wachtwoord',
    passwordPlaceholder: 'Minstens 6 tekens',
    confirmPassword: 'Bevestig wachtwoord',
    confirmPasswordPlaceholder: 'Voer je wachtwoord opnieuw in',
    cancel: 'Annuleren',
    next: 'Volgende',
    previous: 'Vorige',
    submitting: 'Verzenden…',
    continue: 'Doorgaan',
    validateProfile: 'Mijn profiel valideren',
    creating: 'Aanmaken…',
    createAccountAndJoin: 'Mijn account aanmaken en lid worden van de directory',
    confirmCancel: 'Weet je zeker dat je je registratie wilt annuleren?',
    progressStep1: 'Profiel aanmaken',
    progressStep2: 'Account aanmaken',
    progressStep3: 'Bevestiging',
    progressStepAria: 'Stap {step}: {label}',
    validation: {
      pleaseCompleteFields: 'Vul de volgende velden in: {fields}.',
      atLeastOneService: 'Minimaal één dienst',
      atLeastThreePhotos: 'Minimaal 3 foto\'s van je werk',
      completeProfileFirst: 'Voltooi eerst je profiel (stap 1) voordat je je account aanmaakt. Je hebt mogelijk de accountpagina direct geopend.',
      atLeastOneContact: 'Minimaal één contactgegevens',
      primaryContactRequired: 'Primair sociaal netwerk',
      confirmPasswordLabel: 'Wachtwoord bevestigen',
    },
    errorLoadCategories: 'Kan categorieën niet laden.',
    errorCountryNotSupported: 'Dit land wordt nog niet ondersteund. Kies een stad in Europa of Franstalig Afrika.',
    errorImagesOnlyProfile: 'Alleen afbeeldingen zijn toegestaan voor de profielfoto.',
    errorImagesOnlyGallery: 'Alleen afbeeldingen zijn toegestaan voor de galerij.',
    errorProfileCreation: 'Fout bij het aanmaken van het profiel. Probeer het opnieuw.',
    creatingAccount: 'Je account wordt aangemaakt...',
    errorEmailVerification: 'Fout bij het verifiëren van de e-mail. Probeer het opnieuw.',
    errorGeneric: 'Er is een fout opgetreden. Probeer het opnieuw.',
    errorFormNotFound: 'Fout: formulier niet gevonden. Vernieuw de pagina.',
    errorOccurred: 'Er is een fout opgetreden. Probeer het opnieuw.',
    contactFields: {
      instagram: 'Instagram',
      instagramPlaceholder: 'Gebruikersnaam',
      tiktok: 'TikTok',
      tiktokPlaceholder: 'TikTok gebruikersnaam',
      whatsapp: 'WhatsApp',
      whatsappPlaceholder: 'WhatsApp telefoonnummer',
      phone: 'Telefoon',
      phonePlaceholder: 'Telefoonnummer',
      externalLink: 'Externe link',
      externalLinkPlaceholder: 'Bijv: Calendly link',
    },
  },
  // Footer
  footer: {
    navigation: 'Navigatie',
    home: 'Home',
    hairstylists: 'Kapsters',
    posts: 'Posts',
    information: 'Informatie',
    about: 'Over ons',
    faq: 'FAQ',
    contact: 'Contact',
    legal: 'Juridische informatie',
    refund: 'Restitutiebeleid',
    followUs: 'Volg ons',
    instagram: 'Instagram',
    allRightsReserved: 'Alle rechten voorbehouden',
  },
  // Legal Page
  legal: {
    title: 'Juridische informatie',
    lastUpdate: 'Laatst bijgewerkt: 4 december 2025',
    editor: {
      title: '1. Uitgever van de website',
      name: 'Chérie, Coiffer ?',
      editor: 'Project uitgegeven door:',
      editorName: 'Christelle Kabemba',
      country: 'België',
      email: 'E-mail:',
    },
    hosting: {
      title: '2. Hosting',
      text: 'De website wordt gehost door:',
      provider: 'Firebase Hosting – Google LLC',
      address: '1600 Amphitheatre Parkway, Mountain View, CA 94043, USA.',
    },
    purpose: {
      title: '3. Doel van de website',
      description: '<strong>Chérie, Coiffer ?</strong> is een digitaal directory dat het zoeken naar afro kapsters in België en elders vergemakkelijkt. Het doel is om op één plek samen te brengen:',
      items: [
        'kapster-profielen',
        'hun openbare Instagram / TikTok-accounts',
        'hun openbaar zichtbare diensten',
        'hun niet-privé locatie-informatie',
      ],
      goal: 'De website heeft tot doel de zichtbaarheid van kapsters te verbeteren en het leven van klanten te vereenvoudigen.',
    },
    profiles: {
      title: '4. Aanmaak van kapster-profielen',
      public: {
        title: '4.1 Profielen gegenereerd uit openbare informatie',
        text: 'Om klanten te helpen actieve kapsters in België te ontdekken, kunnen sommige profielen worden gemaakt op basis van <strong>openbare en vrij toegankelijke</strong> informatie, zoals:',
        items: [
          'Instagram openbare pseudoniem of naam',
          'openbaar profielfoto',
          'openbaar zichtbare diensten',
          'aangegeven stad of servicegebied',
        ],
        privacy: 'Geen privé-informatie (persoonlijk adres, privé-nummer, gesprekken, etc.) wordt verzameld of gepubliceerd.',
      },
      rights: {
        title: '4.2 Recht op wijziging, verwijdering en beheer van profiel',
        text: 'Elke kapster kan te allen tijde:',
        items: [
          'verzoeken om <strong>onmiddellijke verwijdering</strong> van haar profiel,',
          'verzoeken om <strong>wijziging</strong> van haar informatie,',
          'haar profiel <strong>claimen</strong> om het persoonlijk te beheren.',
        ],
        contact: 'Om dit te doen, stuur gewoon een bericht naar het volgende adres:',
        deletion: 'De verwijdering wordt zo snel mogelijk uitgevoerd, zonder rechtvaardiging vereist.',
      },
    },
    accounts: {
      title: '5. Gebruikersaccounts (klanten en kapsters)',
      text: 'Gebruikers kunnen een account aanmaken om:',
      items: [
        'een professioneel profiel te beheren,',
        'kapsters aan favorieten toe te voegen,',
        'vragen te stellen in het forum,',
        'beoordelingen achter te laten (als de optie is ingeschakeld).',
      ],
      responsibility: 'Elke gebruiker blijft verantwoordelijk voor de informatie die zij publiceert.',
    },
    data: {
      title: '6. Gegevensverzameling en -verwerking',
      text1: 'De enige automatisch verzamelde gegevens zijn anoniem en statistisch (via Google Analytics of equivalent). Geen gevoelige gegevens worden verzameld.',
      text2: 'Geen gegevens zullen worden verkocht of overgedragen.',
    },
    gdpr: {
      title: '7. Uw rechten (AVG)',
      text: 'In overeenstemming met de AVG heeft u het recht op:',
      items: [
        'toegang tot uw gegevens,',
        'rectificatie,',
        'bezwaar,',
        'wissing ("recht om vergeten te worden").',
      ],
      contact: 'Voor elk verzoek:',
    },
    intellectual: {
      title: '8. Intellectueel eigendom',
      text: 'Het ontwerp, het logo, de teksten en de code van de website behoren toe aan Chérie, Coiffer ?. Instagram-profielfoto\'s behoren toe aan hun respectieve eigenaars en worden alleen gebruikt als <strong>niet-commerciële miniaturen</strong> om te linken naar hun openbare pagina\'s.',
    },
    liability: {
      title: '9. Aansprakelijkheid',
      text: 'Chérie, Coiffer ? is niet verantwoordelijk voor:',
      items: [
        'de kwaliteit van diensten verleend door kapsters,',
        'incorrecte informatie op profielen uit openbare bronnen,',
        'beslissingen genomen door klanten.',
      ],
    },
    contact: {
      title: '10. Contact',
      text: 'Voor elke vraag of verzoek betreffende uw gegevens of uw profiel:',
    },
  },
  // FAQ Page
  faq: {
    title: 'Veelgestelde vragen (FAQ)',
    lastUpdate: 'Laatst bijgewerkt:',
    pro: {
      title: '1. PRO-abonnement',
      whatIs: {
        title: '1.1 Wat is het PRO-abonnement?',
        text: 'Het PRO-abonnement is een maandelijks abonnement van <strong>€9,99/maand</strong> dat dienstverleners (kapsters, nagelstylistes, make-up artiesten, wimperstylistes) in staat stelt om te profiteren van premium functies op Chérie Coiffer.',
      },
      benefits: {
        title: '1.2 Wat zijn de voordelen van het PRO-abonnement?',
        text: 'PRO-dienstverleners profiteren van:',
        items: [
          'Verhoogde zichtbaarheid in zoekresultaten',
          'Prioritaire weergave in lijsten',
          'Zichtbare "PRO"-status op hun profiel',
          'Toegang tot gedetailleerde statistieken',
        ],
      },
      subscribe: {
        title: '1.3 Hoe abonneer ik me op het PRO-abonnement?',
        text: 'Om u te abonneren op het PRO-abonnement, moet u eerst een dienstverlener-profiel aanmaken op Chérie Coiffer. Zodra uw profiel is aangemaakt, wordt u doorgestuurd naar de betalingspagina waar u het PRO-abonnement kunt kiezen en betalen via Stripe.',
      },
      cancel: {
        title: '1.4 Hoe kan ik mijn PRO-abonnement annuleren?',
        text: 'Om uw PRO-abonnement te annuleren, neem contact met ons op via e-mail op',
        text2: 'en geef uw annuleringsverzoek aan. We zullen uw verzoek zo snel mogelijk behandelen.',
        important: 'Belangrijk:',
        importantText: 'De annulering wordt van kracht aan het einde van de huidige factureringsperiode. U blijft profiteren van PRO-voordelen tot het einde van deze periode.',
      },
      paymentFailed: {
        title: '1.5 Wat gebeurt er als mijn betaling mislukt?',
        text: 'Bij betalingsfalen ontvangt u een e-mailmelding. U heeft een respijtperiode van 7 dagen om uw betaalmethode bij te werken. Als de betaling niet binnen deze periode wordt gedaan, wordt uw PRO-abonnement automatisch gedeactiveerd en uw account gaat terug naar de gratis (FREE) modus.',
      },
      refund: {
        title: '1.6 Kan ik een terugbetaling krijgen?',
        text: 'Abonnementen worden maandelijks gefactureerd. Bij annulering blijft u profiteren van PRO-voordelen tot het einde van de huidige factureringsperiode. Er wordt geen gedeeltelijke terugbetaling gedaan voor de resterende periode.',
      },
    },
    profile: {
      title: '2. Profiel aanmaken en beheren',
      create: {
        title: '2.1 Hoe maak ik een dienstverlener-profiel aan?',
        text: 'Om een dienstverlener-profiel aan te maken, klik op "Ik ben dienstverlener" in het menu, kies uw type dienst (Haar, Nagels, Make-up, Wimpers) en volg dan de stappen van het registratieformulier.',
      },
      edit: {
        title: '2.2 Kan ik mijn profiel na aanmaak bewerken?',
        text: 'Ja, u kunt uw profiel op elk moment bewerken door in te loggen op uw account en toegang te krijgen tot uw profielbewerkingspagina.',
      },
      delete: {
        title: '2.3 Hoe verwijder ik mijn profiel?',
        text: 'Om uw profiel te verwijderen, neem contact met ons op via',
        text2: 'De verwijdering wordt zo snel mogelijk uitgevoerd.',
      },
    },
    search: {
      title: '3. Zoeken en filters',
      howTo: {
        title: '3.1 Hoe zoek ik naar een dienstverlener?',
        text: 'Gebruik de zoekbalk bovenaan de pagina om te zoeken op naam, type dienst of stad. U kunt ook geavanceerde filters gebruiken om uw zoekopdracht te verfijnen.',
      },
      city: {
        title: '3.2 Hoe werkt filtering op stad?',
        text: 'Filtering op stad toont alleen dienstverleners die deze stad in hun profiel hebben opgegeven (hoofdstad of reissteden). Dienstverleners die kunnen reizen maar uw stad niet hebben opgegeven, worden niet weergegeven in de resultaten.',
      },
    },
    account: {
      title: '4. Gebruikersaccount',
      create: {
        title: '4.1 Hoe maak ik een account aan?',
        text: 'U kunt een account aanmaken door te klikken op "Inloggen" en dan "Registreren". U kunt een account aanmaken als klant of direct als dienstverlener.',
      },
      forgotPassword: {
        title: '4.2 Ik ben mijn wachtwoord vergeten',
        text: 'Klik op "Inloggen" en dan op "Wachtwoord vergeten" en volg de instructies om uw wachtwoord opnieuw in te stellen.',
      },
      delete: {
        title: '4.3 Hoe verwijder ik mijn account?',
        text: 'U kunt uw account verwijderen vanaf de pagina "Accountbeheer" in de instellingen van uw profiel. Deze actie is onomkeerbaar en verwijdert al uw gegevens.',
      },
    },
    reviews: {
      title: '5. Beoordelingen en evaluaties',
      howTo: {
        title: '5.1 Hoe laat ik een beoordeling achter?',
        text: 'Om een beoordeling achter te laten, moet u ingelogd zijn en het profiel van de dienstverlener hebben bekeken. Beoordelingen moeten respectvol zijn en gebaseerd op een echte ervaring.',
      },
      edit: {
        title: '5.2 Kan ik mijn beoordeling bewerken of verwijderen?',
        text: 'Ja, u kunt uw beoordelingen bewerken of verwijderen vanaf uw profielpagina in de sectie "Mijn beoordelingen".',
      },
    },
    support: {
      title: '6. Contact en ondersteuning',
      contact: {
        title: '6.1 Hoe kan ik contact met u opnemen?',
        text: 'Voor elke vraag, verzoek of probleem kunt u contact met ons opnemen via e-mail op',
      },
      response: {
        title: '6.2 Reactietijd',
        text: 'We streven ernaar om alle verzoeken binnen 48 werkuren te beantwoorden.',
      },
    },
  },
  // About Page
  about: {
    title: 'Over ons',
    lastUpdate: 'Laatst bijgewerkt: 4 december 2025',
    mission: {
      title: 'Onze missie',
      text1: '<strong>Chérie, Coiffer ?</strong> is een platform dat het zoeken naar afro kapsters in België (en binnenkort elders) vergemakkelijkt. Het idee is eenvoudig: alle kapsters die actief zijn op Instagram, TikTok of elders op één plek samenbrengen, om klanten te helpen precies te vinden wat ze zoeken, zonder urenlang door sociale netwerken te bladeren.',
      text2: 'Of u nu op zoek bent naar iemand bij u in de buurt, een specialist in een type vlechten, of gewoon haar-inspiratie, ons doel is om deze zoektocht eenvoudiger, duidelijker en toegankelijker te maken.',
    },
    why: {
      title: 'Waarom dit project?',
      text1: 'Na verschillende jaren in het buitenland keerde ik terug om in België te wonen en realiseerde ik me snel een probleem: een betrouwbare kapster vinden was extreem ingewikkeld geworden.',
      text2: 'Alles gaat via Instagram en TikTok, maar als u het juiste <strong>@</strong> niet kent, is het gemakkelijk om een getalenteerde kapster te missen… soms zelfs degene die net twee straten verderop woont.',
      text3: 'Als digitale enthousiast besloot ik een tool te creëren die deze informatie op een eenvoudige, duidelijke en transparante manier centraliseert.',
    },
    profiles: {
      title: 'Hoe worden profielen aangemaakt?',
      text1: 'Om het platform onmiddellijk nuttig te maken, worden sommige kapster-profielen gemaakt op basis van <strong>openbare</strong> informatie die zichtbaar is op hun sociale netwerken (pseudoniem, openbare foto\'s, weergegeven diensten, etc.).',
      text2: '<strong>Elke kapster behoudt volledige controle over haar profiel:</strong>',
      items: [
        'haar profiel claimen om het zelf te beheren;',
        'wijzigingen in informatie aanvragen;',
        'onmiddellijke verwijdering van het profiel aanvragen, zonder rechtvaardiging.',
      ],
      text3: 'Het doel is nooit om Instagram-pagina\'s te vervangen: gewoon om ze gemakkelijker te vinden.',
    },
    name: {
      title: 'Waarom "Chérie, Coiffer ?"',
      text1: 'De naam is een knipoog naar een bekende zin in de gemeenschap:',
      quote: '« Mijn schat, kom, ik doe je haar »',
      text2: 'typisch voor wijken zoals Matongé, waar kapsters klanten benaderen.',
      text3: 'De website weerspiegelt deze geest: een warme, toegankelijke ruimte, ontworpen voor ons.',
    },
    values: {
      title: 'Onze waarden',
      items: [
        '<strong>Toegankelijkheid:</strong> iedereen in staat stellen om een kapster gemakkelijk te vinden.',
        '<strong>Zichtbaarheid:</strong> getalenteerde kapsters helpen beter ontdekt te worden.',
        '<strong>Transparantie:</strong> profielen kunnen op elk moment worden gewijzigd of verwijderd.',
        '<strong>Eenvoud:</strong> een duidelijk platform, zonder complicaties.',
      ],
    },
    contact: {
      title: 'Contact',
      text: 'Voor elke vraag, om een profiel te wijzigen of te claimen, of om samen te werken:',
    },
  },
  // Diensten en categorieën uit Firestore
  // Codes corresponderen met codes in de database
  // Formaat: services.{CODE} of categories.{CODE}
  // Voorbeeld: services.TRESSES_CORNBROWS = "Cornrows"
  // Als een vertaling niet bestaat, wordt het Franse label uit de DB als fallback gebruikt
  services: {
    // Vertalingen worden naar behoefte toegevoegd
    // Voorlopig worden Franse labels uit de DB als fallback gebruikt
  },
  categories: {
    // Vertalingen worden naar behoefte toegevoegd
    // Voorlopig worden Franse labels uit de DB als fallback gebruikt
  },
};
